<template>
  <div>
    <b-form>
      <div class="form-group flex-inline-form-lg">
        <b-input-group class="fill-width">
          <b-input-group-text slot="prepend" >
            <i class="fa fa-search"></i>
          </b-input-group-text>
          <b-form-input
            style="height:auto;"
            ref="searchQuery"
            type="text"
            placeholder="Search user by name or email"
            @input="onChangeSearchQuery($event)"
            :debounce="500"
            v-model="searchQuery"></b-form-input>
        </b-input-group>
        <b-input-group v-if="!hideCompanySelect">
          <company-multi-select
              :multiple="false"
              having="user"
              :init-selection-id="companyIdQuery"
              @on-selected="onCompanySelected"
            />
        </b-input-group>
        <b-input-group style="min-width: 150px;">
          <b-form-select
            style="height:auto;"
            v-model="sortType"
            @change="onChangeSortType($event)"
            :options="sortOptions"> </b-form-select>
        </b-input-group>
        <b-input-group >
          <b-button @click="createUser()" variant="success" :disabled="!myAccess.MAIN.USER.CREATE">New user &nbsp;<i class="fa fa-plus"></i></b-button>
        </b-input-group>
      </div>
    </b-form>
    <div class="list-group mb-2" v-if="totalRows">
      <b-nav>
        <b-nav-item
          v-show="count_active"
          @click="navSelected('ACTIVE')"
          :active="filterType === 'ACTIVE'">Active ({{count_active}})</b-nav-item>
        <b-nav-item
          v-show="count_default"
          @click="navSelected('DEFAULT')"
          :active="filterType === 'DEFAULT'">Default ({{count_default}})</b-nav-item>
        <b-nav-item
          v-show="count_vehicle"
          @click="navSelected('VEHICLE')"
          :active="filterType === 'VEHICLE'">Vehicle ({{count_vehicle}})</b-nav-item>
        <b-nav-item
          v-show="count_system_admin"
          @click="navSelected('SYSTEM_ADMIN')"
          :active="filterType === 'SYSTEM_ADMIN'">System admin ({{count_system_admin}})</b-nav-item>
        <b-nav-item
          v-show="count_admin"
          @click="navSelected('ADMIN')"
          :active="filterType === 'ADMIN'">Admin ({{count_admin}})</b-nav-item>
        <b-nav-item
          v-show="count_inactive"
          @click="navSelected('INACTIVE')"
          :active="filterType === 'INACTIVE'">Blocked ({{count_inactive}})</b-nav-item>
      </b-nav>
    </div>
    <b-overlay :show="isUserListLoading">
      <b-list-group class="no-box" v-if="totalRows">
        <b-list-group-item
          v-for="user in users"
          :key="`${user.id}`"
          >
          <div class="pull-left mr-3 mt-2">
            <img :src="user.avatar" alt="Profile Picture" class="img-user-avatar">
          </div>
          <div class="pull-left">
            <router-link :to="'users/' + user.id"><strong>{{user.full_name == null ? user.username : user.full_name}}</strong>
            <span v-if="currentUserId === user.id">(It's you)</span>
            <b-badge pill variant="info" v-if="user.type === 'SYSTEM_ADMIN'">System Admin</b-badge>
            <b-badge pill variant="success" v-if="user.type === 'ADMIN'">Admin</b-badge>
            <b-badge pill variant="danger" v-if="!user.active">Blocked</b-badge>
            <b-badge pill variant="success" v-if="getUserType(user)">{{getUserType(user)}}</b-badge>
            </router-link>
            <p class="mb-1"><a :href="'mailto:' + user.email" v-if="getUserType(user) != 'Vehicle'">{{user.email}}</a></p>
            <small :title="formatDateTime(user.created_at)">Created at: {{formatDateDistance(user.created_at)}}</small>
          </div>
          <div class="pull-right">
            <b-button
              v-if="myAccess.MAIN.USER.UPDATE && amISuperior(user)"
              variant="outline-primary"
              @click="editUser(user.id)"><i class="fa fa-pencil-square-o"></i>&nbsp; Edit</b-button>
            <b-dropdown variant="outline-primary" class="m-md-2" v-if="amISuperior(user)">
              <i class="fa fa-gear" slot="button-content"></i>
              <b-dropdown-item v-if="myAccess.MAIN.USER.UPDATE" class="text-warning">Disable</b-dropdown-item>
              <b-dropdown-item @click="deleteUser(user.id)" v-if="myAccess.MAIN.USER.DELETE" class="text-danger">Remove</b-dropdown-item>
            </b-dropdown>
          </div>
        </b-list-group-item>
      </b-list-group>
      <div style="height:150px;" v-if="isUserListLoading && totalRows === 0"></div>
    </b-overlay>
    <b-pagination class="mt-3" align="center" size="md" :total-rows="totalRows" v-model="currentPage" :per-page="query_count" v-if="totalRows">
    </b-pagination>
    <b-alert show v-if="isFetched & totalRows === 0">There's no user inside this company.</b-alert>
    <div>
      <b-modal
        id="delete_user"
        title="Delete User"
        header-bg-variant="danger"
        ok-variant="danger"
        @ok="confirmedDeleteUser(deleteUserId)">
        <p class="my-4">Are you sure want to delete this user?</p>
      </b-modal>
    </div>
  </div>
</template>
<script>
import dateMixin from '@/mixins/date';
import userMixin from '@/mixins/user';
import routeQuery from '@/mixins/route_query';
import { isString, debounce, isEmpty, uniqBy, get, capitalize } from 'lodash';

import CompanyMultiSelect from '@/components/CompanyMultiSelect';

export default {
  name: 'user_table',
  mixins: [dateMixin, userMixin, routeQuery],
  components: {
    CompanyMultiSelect,
  },
  props: {
    companyId: {
      type: String,
      required: false,
      default: '',
    },
  },
  data() {
    return {
      deleteUserId: null,
      loaded: false,
      searchQuery: '',
      filterType: 'ACTIVE',
      currentPage: 1,
      companyList: [],
      dataBeforeLoad: [],
      companySelectorLoading: false,
      selectedCompany: null,
      sortOptions: [
        { value: null, text: '== Sort by ==', disabled: true },
        { value: 'FULL_NAME.ASC', text: 'Name A-Z' },
        { value: 'FULL_NAME.DESC', text: 'Name Z-A' },
        { value: 'CREATED_AT.DESC', text: 'Last Created' },
        { value: 'CREATED_AT.ASC', text: 'Oldest Created' },
      ],
      sortType: null,
    };
  },
  created() {
    this.$store.commit('users/CLEAR_QUERY');
    this.$store.commit('users/SET_QUERY_TYPE', null);
    this.$store.commit('users/SET_QUERY_ACTIVE', 'true');
    this.initFromUrl();
  },
  computed: {
    users() {
      const users = this.$store.getters['users/users'];
      return uniqBy(users, 'id');
    },
    count_all() {
      return this.$store.getters['users/count_all'];
    },
    count_default() {
      return this.$store.getters['users/count_default'];
    },
    count_vehicle() {
      return this.$store.getters['users/count_vehicle'];
    },
    count_system_admin() {
      return this.$store.getters['users/count_system_admin'];
    },
    count_admin() {
      return this.$store.getters['users/count_admin'];
    },
    count_active() {
      return this.$store.getters['users/count_active'];
    },
    count_inactive() {
      return this.$store.getters['users/count_inactive'];
    },
    query_count() {
      return this.$store.getters['users/query_count'];
    },
    company_count_all() {
      return this.$store.getters['companies/count_all'];
    },
    myAccess() {
      return this.$store.getters.userAccess;
    },
    totalRows() {
      if (this.filterType === 'DEFAULT') {
        return this.count_default;
      } else if (this.filterType === 'VEHICLE') {
        return this.count_vehicle;
      } else if (this.filterType === 'SYSTEM_ADMIN') {
        return this.count_system_admin;
      } else if (this.filterType === 'ADMIN') {
        return this.count_admin;
      } else if (this.filterType === 'ACTIVE') {
        return this.count_active;
      } else if (this.filterType === 'INACTIVE') {
        return this.count_inactive;
      }
      return this.count_all;
    },
    is_data_loaded() {
      return this.$store.getters['users/dataLoaded'];
    },
    userDataState() {
      return this.$store.getters['users/dataStateUsers'];
    },
    isFetched() {
      return this.userDataState === 'LOADED';
    },
    isUserListLoading() {
      return this.userDataState === 'LOADING';
    },
    hideCompanySelect() {
      return this.companyId !== '';
    },
    companyIdQuery() {
      return this.getRouteQuery('company_id', '');
    },
  },
  watch: {
    currentPage(newValue) {
      if (this.is_data_loaded) {
        this.$store.commit('users/SET_QUERY_PAGE', newValue);
        this.loadData();
      }
    },
  },
  methods: {
    initFromUrl() {
      let fCompanyId = this.getRouteQuery('company_id');
      const sort = this.getRouteQuery('sort');
      const search = this.getRouteQuery('q');
      const type = this.getRouteQuery('type', this.filterType);

      if (this.companyId !== '') {
        fCompanyId = this.companyId;
      }

      if (typeof fCompanyId !== 'undefined') {
        this.setCompanyId({ id: fCompanyId }, true);
      }
      if (sort !== undefined) {
        this.onChangeSortType(sort, true);
      }
      if (search !== undefined) {
        this.onChangeSearchQuery(search, true);
      }
      this.loadInfoAndData(type, true);
    },
    loadInfoAndData(type, fromInit = false) {
      const fType = type || 'ACTIVE';
      this.$store.dispatch('users/LOAD_INFO');
      this.navSelected(fType, fromInit);
    },
    navSelected(type, fromInit) {
      const sameType = this.filterType === type;
      this.filterType = type;
      let queryType = type;
      let active = 'all';

      if (type === 'ACTIVE') {
        queryType = null;
        active = 'true';
      } else if (type === 'INACTIVE') {
        queryType = null;
        active = 'false';
      }

      if (!fromInit && !sameType) {
        if (type === 'ACTIVE') {
          this.removeRouteQuery('type');
        } else {
          this.setRouteQuery('type', type);
        }
      }

      this.currentPage = 1;
      this.$store.commit('users/SET_QUERY_PAGE', 1);
      this.$store.commit('users/SET_QUERY_TYPE', queryType);
      this.$store.commit('users/SET_QUERY_ACTIVE', active);
      this.loadData();
    },
    updateSearchQuery: debounce((context, searchTerm) => {
      const searchQuery = isString(searchTerm) ? searchTerm.trim() : '';
      context.$store.commit('users/SET_QUERY_SEARCH', searchQuery);
      context.loadInfoAndData(context.filterType);
    }, 500),
    loadData() {
      return this.$store.dispatch('users/LOAD_DATA');
    },
    editUser(userId) {
      this.$router.push(`/admin/users/${userId}/edit`);
    },
    createUser() {
      this.$router.push('/admin/users/create');
    },
    deleteUser(userId) {
      this.deleteUserId = userId;
      this.$bvModal.show('delete_user');
    },
    confirmedDeleteUser(userId) {
      this.$store.dispatch('users/DELETE_DATA', userId).then((ok) => {
        if (ok) this.loadInfoAndData();
      });
    },
    onCompanySelected(selected) {
      this.setCompanyId(selected);
      this.loadInfoAndData();
    },
    setCompanyId(selected, fromInit = false) {
      if (typeof selected !== 'undefined' && selected !== null) {
        this.$store.commit('users/SET_COMPANY_ID', selected.id);
        const currId = this.getRouteQuery('company_id', '');
        if (!fromInit && selected.id !== currId) {
          this.setRouteQuery('company_id', selected.id);
        }
      } else {
        this.$store.commit('users/SET_COMPANY_ID', null);
        if (!fromInit) {
          this.removeRouteQuery('company_id');
        }
      }
    },
    onChangeSortType(newValue, fromInit = false) {
      if (!fromInit) {
        this.setRouteQuery('sort', newValue);
      }
      this.$store.commit('users/SET_QUERY_SORT', newValue);
      this.sortType = newValue;

      if (!fromInit) {
        this.loadData();
      }
    },
    onChangeSearchQuery(newValue, fromInit = false) {
      this.$store.commit('users/SET_QUERY_SEARCH', newValue);
      if (!fromInit) {
        if (!isEmpty(newValue)) {
          this.setRouteQuery('q', newValue);
        } else {
          this.removeRouteQuery('q');
        }
      }
      this.searchQuery = newValue;

      if (!fromInit) {
        this.updateSearchQuery(this, newValue);
      }
    },
    getUserType(user) {
      const employee = get(user, 'employee');
      const vehicle = get(user, 'vehicle');
      let type = false;

      if (!isEmpty(employee) || !isEmpty(vehicle)) {
        type = isEmpty(vehicle) ? capitalize(employee.type) : 'Vehicle';
        if (type !== 'Loader' && type !== 'Driver' && type !== 'Vehicle') type = false;
      }

      return type;
    },
  },
};
</script>
<style lang="sass" scoped>
.img-user-avatar
  border-radius: 50%
  border: 1px #9E9E9E solid
  width: 50px
  height: 50px
  display: block
  overflow: hidden

.list-group > .d-flex > div:last-child
  margin-left: auto
</style>



// WEBPACK FOOTER //
// src/components/UserTable.vue